module.exports = "/_next/static/images/8131b0f64b321b5a92fa19586b2a6082-image-right-xs.jpg.webp";